import type { SelectEntityDialogTypes } from "../../../_loadingHelpers/SelectEntityDialog" // type-only: breaks the EntityViewTypes->SED-loader ESM cycle edge

namespace EntityViewTypes {
    export interface EntityViewResponse<T> {
        //isHtmlContent?: boolean, // nimmer benötigt
        content: string,
        entity?: T,
        label?: string,
        entityId?: string,
        entityClassname?: string
    }

    export interface ActionParameters {
        node: HTMLElement,
        entityId: string,
        entityClass: string,
        callfunctionName: string,
        actionType: actionType,
        contextName?: string,
        //actionName?: string
        attributepath?: string,
        originalvalue?: string,
        additionalConfig?: any
    };
    export interface ActionResponse<T> { success: boolean, result: T, message?: string, messageLong?: string, errorMessage?: string, actionType: actionType, originalActionType: actionType }

    export interface UserInputConfig { type: inputType, buttons?: Array<UserInputCustomButton>, title: string, message: string, inputEnabledOnStart?: boolean }
    export interface UserInputConfigWithSelectEntityDialog<T> extends SelectEntityDialogTypes.DlgConfiguration<T> { type: inputType, buttons?: Array<UserInputCustomButton>, title: string, message: string }

    export interface UserInputCustomButton {
        label: string,
        value: string,
        description?: string
        icon?: string;
    }
    export interface RequestBaseData {
        entityID: string
        entityClass: string
        contextURL: string
        contextName: string
        //    contextValues?: Array<{
        //        name: string,
        //        value: string | number | boolean
        //    }>
    }

    export interface setupConfig {
        entityId: string,
        entityClass: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,
        targetNode?: HTMLElement,
        nonInteractive?: boolean
    }

    export interface ActionRequestData extends RequestBaseData {
        parameters: { /*actionName: string,*/ attributepath?: string, userselect?: string | number | Array<string>, filterpanelData?: Object, inputDialogType?: string, },
        functionname: string,
        actiontype: actionType,

    }
    export type inputType = "filterpanel" | "filterpanelwithoverflow" | "ok" | "yes" | "yesno" | "yesnocancel" | "custombuttons" | "selectentitydialog" | "multilineinput" | "textinput" | "dateinput" | "timeinput" | "datetimeinput" | "numberinput"
    export type privilegeType = "edit" | "read" | "delete" | "create" | "clone";

    export type actionType = "ENTITYVIEW" | "ACTION" | "DOWNLOAD" | "USERINPUT" | "SELECTENTITYDIALOGSEARCH" | "CHECKBOX" | "ATTRIBUTEEDIT"

    export interface EnityFrameOptions<T = any> {
        requestDataFunctionname?: string,
        entityClassname: string,
        entityClassPrintname: string,
        idProperty?: string,
        labelProperty?: string,
        additionalRequestParams?: Object
        colorProperty?: string,
        nonInteractive?: boolean;
        cloneOptions?: {
            userroleClone?: string | Array<string>,
            featurePathClone?: string,
        }
        deleteOptions?: {
            featurePathDelete?: string,
            userroleDelete?: string | Array<string>,
            deleteEntityFunctionname?: string,
        }
        editOptions?: {
            userroleEdit?: string | Array<string>,            
            featurePathEdit?: string,
            onChangedEventName: string,
            onDeletedEventName: string,
            onSavedEventName: string

        }

    }

    export interface ButtonConfig {
        internalName: string,
        label: string,
        callback: Function,
        tooltip?: string,
        styleClass?: string,
        iconClass?: string,
        bCloseOnClick?: boolean,
        position?: "first" | "last" | "left first" | "left last" | "top first" | "top last" | number,
        enabled?: boolean,
        node?: HTMLElement;
        hasNextLevel?: boolean;
        hasPreviousLevel?: boolean;
        groupname?: string;
    }

    export type DisplayMode = "dlg" | "tab" | "node";
}

export {
    EntityViewTypes
}